(() => {
  if (window.plpPricesInitialized) return;
  window.plpPricesInitialized = true;

  const priceSelector = '.product-price, .money, .field-price .from, .field-price .to, .js-product-price, .js-product-compare-price, [data-unit-price], .price-regular, .price-sale';

  function formatPriceText(text) {
    return text.replace(/\d[\d,]*(?:\.\d+)?/g, (amount) => {
      const [integer, fraction] = amount.split('.');
      const digits = integer.replace(/,/g, '');
      const leading = digits.slice(0, -3);
      const grouped = leading
        ? `${leading.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${digits.slice(-3)}`
        : digits;
      return fraction === undefined ? grouped : `${grouped}.${fraction}`;
    });
  }

  function formatPrices(root) {
    root.querySelectorAll(priceSelector).forEach((price) => {
      const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const formatted = formatPriceText(node.nodeValue);
        if (node.nodeValue !== formatted) node.nodeValue = formatted;
      }
    });
  }

  function initialize() {
    document.querySelectorAll('.page-collection, .template-product [data-section-type="product-template"], .template-product .sticky-cart-single').forEach((root) => {
      if (root.dataset.plpPricesInitialized) return;
      root.dataset.plpPricesInitialized = 'true';
      formatPrices(root);
      const observer = new MutationObserver(() => {
        observer.disconnect();
        formatPrices(root);
        observe();
      });
      const observe = () => observer.observe(root, {
        childList: true,
        characterData: true,
        subtree: true
      });
      observe();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
